import { SVGProps, Ref, forwardRef } from 'react';

export const LightbulbOnFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path d="M10.4 13.6c0 1.8-1.2 2.4-2.4 2.4s-2.4-.6-2.4-2.4v-.233h4.8z" fill="currentColor" />
                <path
                    d="M8 4a4 4 0 0 1 3.64 5.66 109 109 0 0 0-1.037 2.307H5.397c-.182-.434-.522-1.182-1.037-2.308A4 4 0 0 1 8 4"
                    fill="currentColor"
                />
                <path d="M2.646 7.3q-.045.345-.046.7.001.355.046.7H0V7.3z" fill="currentColor" />
                <path d="M16 8.7h-2.646q.045-.345.046-.7-.001-.355-.046-.7H16z" fill="currentColor" />
                <path d="M4.709 3.719a5.4 5.4 0 0 0-.99.99L1.848 2.838l.99-.99z" fill="currentColor" />
                <path d="m14.151 2.838-1.87 1.871a5.4 5.4 0 0 0-.991-.99l1.872-1.87z" fill="currentColor" />
                <path d="M8.7 2.646A5.5 5.5 0 0 0 8 2.6q-.355.001-.7.046V0h1.4z" fill="currentColor" />
            </g>
        </g>
    </svg>
));
LightbulbOnFilledSize16Glyph.displayName = 'LightbulbOnFilledSize16Glyph';
